module.exports = __webpack_public_path__ + "static/media/IMG_2965-2.e882d5d4.jpg";